export default "__VITE_ASSET__BxU2EQle__"